module.exports = __webpack_public_path__ + "img/TrolleSuchen.01ef679f.svg";